import { Subject } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class Metrics {
  fetchMetricsOptionsErrorMessage = new Subject<any>();
  updateMetricsValues: Subject<any> = new Subject();
}
